<template>
  <div class="c-survey__inner c-survey__bg--blue">
    <div class="c-survey__content c-survey__content--padding">
      <main class="c-survey__html" v-html="summary.content"></main>

      <h3 class="white-text">Your choices:</h3>

      <div class="c-survey__grid c-survey__grid--summary-choices">
        <div class="c-survey__choice-wrapper" :style="{ backgroundColor: sections.sectionOne.sectionColour }">
          <h3 class="white-text">{{ sections.sectionOne.label }}</h3>
          <div class="c-survey__choice-content">
            <img v-if="sections.sectionOne.imageFile" :src="sections.sectionOne.imageFile" class="c-survey__choice-image" />
            <div class="c-survey__choice-tokens">
              <h2 class="white-text">{{ submissionData.sectionOneTokens }}</h2>
            </div>
          </div>
        </div>
        <div class="c-survey__choice-wrapper" :style="{ backgroundColor: sections.sectionTwo.sectionColour }">
          <h3 class="white-text">{{ sections.sectionTwo.label }}</h3>
          <div class="c-survey__choice-content">
            <img v-if="sections.sectionTwo.imageFile" :src="sections.sectionTwo.imageFile" class="c-survey__choice-image" />
            <div class="c-survey__choice-tokens">
              <h2 class="white-text">{{ submissionData.sectionTwoTokens }}</h2>
            </div>
          </div>
        </div>
        <div class="c-survey__choice-wrapper" :style="{ backgroundColor: sections.sectionThree.sectionColour }">
          <h3 class="white-text">{{ sections.sectionThree.label }}</h3>
          <div class="c-survey__choice-content">
            <img v-if="sections.sectionThree.imageFile" :src="sections.sectionThree.imageFile" class="c-survey__choice-image" />
            <div class="c-survey__choice-tokens">
              <h2 class="white-text">{{ submissionData.sectionThreeTokens }}</h2>
            </div>
          </div>
        </div>
      </div>

      <h3 class="white-text">You also selected '{{ questionYesNo }}' {{ summary.questionDescription }}</h3>
    </div>
    <div class="c-survey__content c-survey__content--padding c-survey__content--white-bg">
      <main class="c-survey__html">
        <h1>Outcome</h1>
        <div v-html="outcomes[displayedOutcome]" v-if="displayedOutcome"></div>
        <div v-html="outcomes.questionYes" v-if="submissionData.questionAnswer"></div>
        <div v-html="outcomes.questionNo" v-if="!submissionData.questionAnswer"></div>
      </main>

      <div class="c-survey__actionbutton-row c-survey__actionbutton-row--right">
        <ActionButton :title="summary.summaryNextLabel" :buttonAction="'submit'" :nextView="settings.feedbackEnabled ? 'FeedbackView' : 'ThankyouView'"></ActionButton>
      </div>
    </div>
    <div class="c-survey__content-spacer"></div>
  </div>
</template>
<script>
import { mapFields } from "vuex-map-fields";
import ActionButton from "../ActionButton.vue";

export default {
  created() {},
  components: { ActionButton },
  mounted() {},
  methods: {},
  computed: {
    ...mapFields(["content.settings", "content.sections", "content.outcomes", "content.pages.summary", "submissionData"]),

    displayedOutcome() {
      const { sectionOneTokens, sectionTwoTokens, sectionThreeTokens } = this.submissionData;

      const tokenCounts = {
        sectionOneTokens,
        sectionTwoTokens,
        sectionThreeTokens,
      };

      const maxToken = Math.max(sectionOneTokens, sectionTwoTokens, sectionThreeTokens);

      const topSections = Object.keys(tokenCounts).filter((key) => tokenCounts[key] === maxToken);

      if (topSections.length === 3) {
        // NOTE: while this is in, the logic/cms currently doesn't account for a tie.
        return null;
      }

      let outcomeToDisplay = "";

      if (topSections.length === 2) {
        outcomeToDisplay = topSections
          .sort()
          .join("")
          .replace(/Tokens/g, "")
          .replace(/section/g, "");
      } else {
        outcomeToDisplay = topSections[0].replace(/Tokens/g, "").replace(/section/g, "");
      }

      console.log(outcomeToDisplay);

      return "content" + outcomeToDisplay;
    },

    questionYesNo() {
      return this.submissionData.questionAnswer ? "Yes" : "No";
    },
  },
};
</script>
